import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { InfoBox } from '../layout/InfoBox';

export const Container = styled(InfoBox)`
  margin: 30px 0;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 15px 40px;
  padding: 15px 0 0;

  p {
    color: ${({ theme }) => theme.textDark};
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.keyline};
  }

  p:nth-last-of-type(-n + 2) {
    border-bottom: none;
  }

  @media (${tabletMax}) {
    gap: 15px;
    padding: 15px 0 0;

    p {
      padding-bottom: 15px;
    }
  }
`;
